import { IModel, Model, ModelRecord } from './Model';

export interface IVaccineAdministeredModel extends IModel {
  vaccineAdministeredId: number;
  name: string;
}

export class VaccineAdministeredModel
  extends Model
  implements ModelRecord<IVaccineAdministeredModel>
{
  vaccineAdministeredId: number;
  name: string;

  constructor(params?: Partial<IVaccineAdministeredModel>) {
    super(params);
    this.vaccineAdministeredId = _.defaultTo(params?.vaccineAdministeredId, 0);
    this.name = _.defaultTo(params?.name, '');
  }
}
